export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7590.393ad9ea.jpg";